import { Link } from "react-router-dom";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";

export function MeetingMinutesShell({
  eyebrow,
  title,
  subtitle,
  backTo,
  backLabel,
  actions,
  children,
  maxWidth = "max-w-6xl",
}) {
  return (
    <div className="min-h-screen bg-slate-50">
      <div className={`mx-auto ${maxWidth} px-4 py-8 sm:px-6 lg:px-8`}>
        <div className="mb-8 rounded-[2rem] border border-slate-200 bg-white px-6 py-6 shadow-sm">
          {backTo ? (
            <Link
              to={backTo}
              className="mb-4 inline-flex items-center gap-2 rounded-full border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-slate-700 transition hover:border-slate-400 hover:bg-slate-50"
            >
              <ArrowLeftIcon className="h-4 w-4" />
              {backLabel}
            </Link>
          ) : null}
          {eyebrow ? (
            <div className="mb-3 inline-flex items-center gap-2 rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold uppercase tracking-[0.2em] text-slate-600">
              {eyebrow}
            </div>
          ) : null}
          <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
            <div className="min-w-0">
              <h1 className="text-3xl font-semibold tracking-tight text-slate-950">{title}</h1>
              {subtitle ? <p className="mt-2 max-w-2xl text-sm text-slate-600">{subtitle}</p> : null}
            </div>
            {actions ? <div className="flex flex-wrap gap-2">{actions}</div> : null}
          </div>
        </div>
        {children}
      </div>
    </div>
  );
}

export function mmPrimaryButtonClass(extra = "") {
  return `inline-flex items-center justify-center gap-2 rounded-full bg-slate-900 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-slate-800 disabled:opacity-60 ${extra}`;
}

export function mmSecondaryButtonClass(extra = "") {
  return `inline-flex items-center justify-center gap-2 rounded-full border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-slate-700 transition hover:bg-slate-50 disabled:opacity-60 ${extra}`;
}

export function mmCardClass(extra = "") {
  return `overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-sm ${extra}`;
}
